import { PageLoader } from '@doltech/ui/lib/figma/PageLoader/PageLoader';
import { PageTypeEnum } from '@doltech/utils/lib/constants';
import dynamic from 'next/dynamic';
import * as React from 'react';
import { CommonLayout } from './commons';
import { FABLandingHome } from '@doltech/modules/lib/landing-home/components/FABLandingHome';
import { ContactDol } from '@doltech/ui/lib/figma/ContactDol/ContactDol';

const DoDictationTemplatePage = dynamic(
  () => import('../templates/DoDictationTemplatePage').then((mod) => mod.DoDictationTemplatePage),
  { loading: () => <CommonLayout /> }
);
const IeltsFullTestTemplatePage = dynamic(() => import('../templates/IeltsFullTestTemplatePage'), {
  loading: () => <CommonLayout />,
});

const BookSEOPageTemplate = dynamic(
  () => import('../templates/BookSEOPageTemplate').then((mod) => mod.BookSEOPageTemplate),
  { loading: () => <CommonLayout /> }
);
const LandingDictationTemplatePage = dynamic(
  () => import('../templates/LandingDictationTemplatePage'),
  { loading: () => <CommonLayout /> }
);

const K12ExamTestLandingPage = dynamic(
  () =>
    import('@doltech/modules/lib/k12/landing/listing/ExamTestLanding').then(
      (mod) => mod.ExamTestLanding
    ),
  { loading: () => <CommonLayout /> }
);

const K12OthersExamTestLandingPage = dynamic(
  () =>
    import('@doltech/modules/lib/k12/landing-others/listing/ExamTestOthersLanding').then(
      (mod) => mod.ExamTestOthersLanding
    ),
  { loading: () => <CommonLayout /> }
);

const K12DoExamTestPage = dynamic(
  () =>
    import('@doltech/modules/lib/k12/landing/do-test/DoExamTestMainContent').then(
      (mod) => mod.DoExamTestMainContent
    ),
  { loading: () => <CommonLayout /> }
);

const K12OthersDoExamTestPage = dynamic(
  () =>
    import('@doltech/modules/lib/k12/landing-others/do-test-others/DoExamTestOthersMainContent').then(
      (mod) => mod.DoExamTestOthersMainContent
    ),
  { loading: () => <CommonLayout /> }
);

const K12BookPage = dynamic(
  () =>
    import('@doltech/modules/lib/k12/landing/book/K12BookMainContent').then(
      (mod) => mod.K12BookMainContent
    ),
  { loading: () => <CommonLayout /> }
);

const K12OthersBookPage = dynamic(
  () =>
    import('@doltech/modules/lib/k12/landing-others/book-others/K12OthersBookMainContent').then(
      (mod) => mod.K12OthersBookMainContent
    ),
  { loading: () => <CommonLayout /> }
);

const K12ExamTestBlogPage = dynamic(
  () =>
    import('@doltech/modules/lib/k12/landing/view-test-blog/ExamTestBlog').then(
      (mod) => mod.ExamTestBlog
    ),
  { loading: () => <CommonLayout /> }
);

const K12OthersExamTestBlogPage = dynamic(
  () =>
    import('@doltech/modules/lib/k12/landing-others/view-test-blog-others/ExamTestBlogOthers').then(
      (mod) => mod.ExamTestBlogOthers
    ),
  { loading: () => <CommonLayout /> }
);

const K12ExamBlogLayout = dynamic(
  () =>
    import('@doltech/modules/lib/k12/shared/template/ExamBlogLayout').then(
      (mod) => mod.ExamBlogLayout
    ),
  { loading: () => <CommonLayout /> }
);

const K12ExamTestViewSolutionPage = dynamic(
  () =>
    import('@doltech/modules/lib/k12/landing/view-solution/ExamTestViewSolutionMainContent').then(
      (mod) => mod.ExamTestViewSolutionMainContent
    ),
  { loading: () => <CommonLayout /> }
);

const K12ExamTestOthersViewSolutionPage = dynamic(
  () =>
    import('@doltech/modules/lib/k12/landing-others/view-solution-others/ExamTestOthersViewSolutionMainContent').then(
      (mod) => mod.ExamTestOthersViewSolutionMainContent

    ),
  { loading: () => <CommonLayout /> }
);


const K10ExamTestLandingPage = dynamic(
  () =>
    import('@doltech/modules/lib/k10/landing/listing/ExamTestLanding').then(
      (mod) => mod.ExamTestLanding
    ),
  { loading: () => <CommonLayout /> }
);

const K10DoExamTestPage = dynamic(
  () =>
    import('@doltech/modules/lib/k10/landing/do-test/DoExamTestMainContent').then(
      (mod) => mod.DoExamTestMainContent
    ),
  { loading: () => <CommonLayout /> }
);

const K10BookPage = dynamic(
  () =>
    import('@doltech/modules/lib/k10/landing/book/K10BookMainContent').then(
      (mod) => mod.K10BookMainContent
    ),
  { loading: () => <CommonLayout /> }
);

const K10ExamTestBlogPage = dynamic(
  () =>
    import('@doltech/modules/lib/k10/landing/view-test-blog/ExamTestBlog').then(
      (mod) => mod.ExamTestBlog
    ),
  { loading: () => <CommonLayout /> }
);

const K10ExamBlogLayout = dynamic(
  () =>
    import('@doltech/modules/lib/k10/shared/template/ExamBlogLayout').then(
      (mod) => mod.ExamBlogLayout
    ),
  { loading: () => <CommonLayout /> }
);

const K10ExamTestViewSolutionPage = dynamic(
  () =>
    import('@doltech/modules/lib/k10/landing/view-solution/ExamTestViewSolutionMainContent').then(
      (mod) => mod.ExamTestViewSolutionMainContent
    ),
  { loading: () => <CommonLayout /> }
);

const HSALandingPage = dynamic(
  () => import('@doltech/modules/lib/hsa/landing/listing/HSALanding').then((mod) => mod.HSALanding),
  { loading: () => <CommonLayout /> }
);

const HSABookPage = dynamic(
  () =>
    import('@doltech/modules/lib/hsa/landing/book/HSABookMainContent').then(
      (mod) => mod.HSABookMainContent
    ),
  { loading: () => <CommonLayout /> }
);

const HSAFullTestViewSolutionPage = dynamic(
  () =>
    import(
      '@doltech/modules/lib/hsa/landing/view-solution/full-test/FullTestViewSolutionMainContent'
    ).then((mod) => mod.FullTestViewSolutionMainContent),
  { loading: () => <CommonLayout /> }
);

const HSAFullTestViewTestBlog = dynamic(
  () =>
    import('@doltech/modules/lib/hsa/landing/view-test-blog/full-test/FullTestBlog').then(
      (mod) => mod.FullTestBlog
    ),
  { loading: () => <CommonLayout /> }
);

const HSADoExamTestPage = dynamic(
  () =>
    import('@doltech/modules/lib/hsa/landing/do-test/full-test/DoFullTestMainContent').then(
      (mod) => mod.DoFullTestMainContent
    ),
  { loading: () => <CommonLayout /> }
);

const LandingListeningPracticeTestTemplatePage = dynamic(
  () => import('../templates/LandingListeningPracticeTestTemplatePage'),
  { loading: () => <CommonLayout /> }
);
const LandingReadingPracticeTestTemplatePage = dynamic(
  () => import('../templates/LandingReadingPracticeTestTemplatePage'),
  { loading: () => <CommonLayout /> }
);
const ViewTestQuestionTemplatePage = dynamic(
  () => import('../templates/ViewTestQuestionTemplatePage'),
  { loading: () => <CommonLayout /> }
);
const ViewVocabTemplatePage = dynamic(() => import('../templates/ViewVocabTemplatePage'), {
  loading: () => <PageLoader />,
});

const DoTestTemplatePage = dynamic(() => import('../templates/DoTestTemplatePage'), {
  loading: () => <PageLoader />,
});

const ViewSolutionTemplatePage = dynamic(() => import('../templates/ViewSolutionTemplatePage'), {
  loading: () => <PageLoader />,
});
const HomePageTemplatePage = dynamic(() => import('../templates/HomePageTemplatePage'), {
  loading: () => <CommonLayout />,
});
const LandingDailyLearningTemplatePage = dynamic(
  () => import('../templates/LandingDailyLearningTemplatePage'),
  { loading: () => <CommonLayout /> }
);

const DailyLearningNewsTemplatePage = dynamic(
  () => import('../templates/DailyLearningNewsTemplatePage'),
  { loading: () => <CommonLayout /> }
);

const IeltsFullTestTemplatePageLayout = dynamic(
  () =>
    import('../templates/IeltsFullTestTemplatePage').then(
      (mod) => mod.IeltsFullTestTemplatePageLayout
    ),
  { loading: () => <CommonLayout /> }
);
const LandingDictationTemplatePageLayout = dynamic(
  () =>
    import('../templates/LandingDictationTemplatePage').then(
      (mod) => mod.DictationLandingTemplatePageLayout
    ),
  { loading: () => <CommonLayout /> }
);
const LandingPracticeTestTemplatePageLayout = dynamic(
  () =>
    import('../templates/LandingReadingPracticeTestTemplatePage').then(
      (mod) => mod.LandingPracticeTestTemplatePageLayout
    ),
  { loading: () => <CommonLayout /> }
);
const HomePageTemplatePageLayout = dynamic(
  () => import('../templates/HomePageTemplatePage').then((mod) => mod.HomePageTemplatePageLayout),
  { loading: () => <CommonLayout /> }
);
const LandingWritingSampleTemplatePage = dynamic(
  () => import('../templates/LandingWritingSampleTemplatePage'),
  { loading: () => <CommonLayout loading /> }
);

const LandingSpeakingSampleTemplatePage = dynamic(
  () => import('../templates/LandingSpeakingSampleTemplatePage'),
  { loading: () => <CommonLayout loading /> }
);

const LandingWritingSampleTaskTemplatePage = dynamic(
  () => import('../templates/LandingWritingSampleTaskTemplatePage'),
  { loading: () => <CommonLayout loading /> }
);

const LandingSpeakingSamplePartTemplatePage = dynamic(
  () => import('../templates/LandingSpeakingSamplePartTemplatePage'),
  { loading: () => <CommonLayout /> }
);

const WritingSampleDetailTemplatePageLayout = dynamic(
  () =>
    import('../templates/WritingSampleDetailTemplatePage').then(
      (mod) => mod.WritingSampleDetailTemplatePageLayout
    ),
  { loading: () => <CommonLayout /> }
);

const WritingSampleDetailTemplatePage = dynamic(
  () => import('../templates/WritingSampleDetailTemplatePage'),
  { loading: () => <CommonLayout /> }
);

const LandingSampleLayoutWithPromotion = dynamic(
  () =>
    import('@doltech/ui/lib/figma/Layout/Landing/PremadeLayout/LandingSampleLayoutWithPromotion'),
  {
    loading: () => <CommonLayout />,
  }
);

const LandingBlogDetailSampleLayout = dynamic(
  () => import('@doltech/ui/lib/figma/Layout/Landing/PremadeLayout/LandingBlogDetailSampleLayout'),
  {
    loading: () => <CommonLayout />,
  }
);

const SpeakingSampleDetailTemplatePage = dynamic(
  () => import('../templates/SpeakingSampleDetailTemplatePage'),
  {
    loading: () => <CommonLayout />,
  }
);

export const PageTemplate = ({ pageType, pageProps }) => {
  return (
    <>
      {pageType === PageTypeEnum.WRITING_SAMPLE_DETAIL && (
        <LandingBlogDetailSampleLayout pageProps={pageProps}>
          <WritingSampleDetailTemplatePageLayout {...pageProps}>
            <WritingSampleDetailTemplatePage {...pageProps} />
          </WritingSampleDetailTemplatePageLayout>
        </LandingBlogDetailSampleLayout>
      )}

      {pageType === PageTypeEnum.SPEAKING_SAMPLE_DETAIL && (
        <LandingBlogDetailSampleLayout pageProps={pageProps}>
          <WritingSampleDetailTemplatePageLayout {...pageProps}>
            <SpeakingSampleDetailTemplatePage {...pageProps} />
          </WritingSampleDetailTemplatePageLayout>
        </LandingBlogDetailSampleLayout>
      )}
      {pageType === PageTypeEnum.LANDING_WRITING_SAMPLE && (
        <LandingSampleLayoutWithPromotion pageType={pageType} pageProps={pageProps}>
          <LandingWritingSampleTemplatePage {...pageProps} />
        </LandingSampleLayoutWithPromotion>
      )}
      {pageType === PageTypeEnum.LANDING_SPEAKING_SAMPLE && (
        <LandingSampleLayoutWithPromotion pageType={pageType} pageProps={pageProps}>
          <LandingSpeakingSampleTemplatePage {...pageProps} />
        </LandingSampleLayoutWithPromotion>
      )}
      {pageType === PageTypeEnum.LANDING_WRITING_SAMPLE_T2A && (
        <LandingSampleLayoutWithPromotion pageType={pageType} pageProps={pageProps}>
          <FABLandingHome />
          <ContactDol />
          <LandingWritingSampleTaskTemplatePage {...pageProps} />
        </LandingSampleLayoutWithPromotion>
      )}
      {pageType === PageTypeEnum.LANDING_WRITING_SAMPLE_T1 && (
        <LandingSampleLayoutWithPromotion pageType={pageType} pageProps={pageProps}>
          <FABLandingHome />
          <ContactDol />
          <LandingWritingSampleTaskTemplatePage {...pageProps} />
        </LandingSampleLayoutWithPromotion>
      )}
      {pageType === PageTypeEnum.LANDING_WRITING_SAMPLE_T2G && (
        <LandingSampleLayoutWithPromotion pageType={pageType} pageProps={pageProps}>
          <FABLandingHome />
          <ContactDol />
          <LandingWritingSampleTaskTemplatePage {...pageProps} />
        </LandingSampleLayoutWithPromotion>
      )}
      {pageType === PageTypeEnum.LANDING_SPEAKING_SAMPLE_P1 && (
        <LandingSampleLayoutWithPromotion pageType={pageType} pageProps={pageProps}>
          <FABLandingHome />
          <ContactDol />
          <LandingSpeakingSamplePartTemplatePage {...pageProps} />
        </LandingSampleLayoutWithPromotion>
      )}

      {pageType === PageTypeEnum.LANDING_SPEAKING_SAMPLE_P2 && (
        <LandingSampleLayoutWithPromotion pageType={pageType} pageProps={pageProps}>
          <FABLandingHome />
          <ContactDol />
          <LandingSpeakingSamplePartTemplatePage {...pageProps} />
        </LandingSampleLayoutWithPromotion>
      )}
      {pageType === PageTypeEnum.LANDING_SPEAKING_SAMPLE_P3 && (
        <LandingSampleLayoutWithPromotion pageType={pageType} pageProps={pageProps}>
          <FABLandingHome />
          <ContactDol />
          <LandingSpeakingSamplePartTemplatePage {...pageProps} />
        </LandingSampleLayoutWithPromotion>
      )}
      {pageType === PageTypeEnum.LANDING_HOME && (
        <HomePageTemplatePageLayout {...pageProps}>
          <HomePageTemplatePage {...pageProps} />
        </HomePageTemplatePageLayout>
      )}

      {pageType === PageTypeEnum.VIEW_TEST_QUESTION && (
        <ViewTestQuestionTemplatePage {...pageProps} />
      )}

      {pageType === PageTypeEnum.VIEW_SOLUTION && <ViewSolutionTemplatePage {...pageProps} />}

      {pageType === PageTypeEnum.VIEW_VOCAB && <ViewVocabTemplatePage {...pageProps} />}

      {pageType === PageTypeEnum.LANDING_FULL_TEST && (
        <IeltsFullTestTemplatePageLayout {...pageProps}>
          <FABLandingHome />
          <ContactDol />
          <IeltsFullTestTemplatePage {...pageProps} />
        </IeltsFullTestTemplatePageLayout>
      )}

      {pageType === PageTypeEnum.LANDING_READING_PRACTICE_TEST && (
        <LandingPracticeTestTemplatePageLayout {...pageProps}>
          <FABLandingHome />
          <ContactDol />
          <LandingReadingPracticeTestTemplatePage {...pageProps} />
        </LandingPracticeTestTemplatePageLayout>
      )}

      {pageType === PageTypeEnum.LAND_K12_EXAM_BOOK && (
        <LandingPracticeTestTemplatePageLayout {...pageProps}>
          <FABLandingHome />
          <ContactDol />
          <K12ExamTestLandingPage {...pageProps} />
        </LandingPracticeTestTemplatePageLayout>
      )}

      {pageType === PageTypeEnum.LAND_K12_MATH_EXAM_BOOK && (
        <LandingPracticeTestTemplatePageLayout {...pageProps}>
          <FABLandingHome />
          <ContactDol />
          <K12OthersExamTestLandingPage {...pageProps} />
        </LandingPracticeTestTemplatePageLayout>
      )}
      {pageType === PageTypeEnum.LAND_K12_INFORMATICS_EXAM_BOOK && (
        <LandingPracticeTestTemplatePageLayout {...pageProps}>
          <FABLandingHome />
          <K12OthersExamTestLandingPage {...pageProps} />
        </LandingPracticeTestTemplatePageLayout>
      )}
      {pageType === PageTypeEnum.LAND_K12_PHYSICS_EXAM_BOOK && (
        <LandingPracticeTestTemplatePageLayout {...pageProps}>
          <FABLandingHome />
          <K12OthersExamTestLandingPage {...pageProps} />
        </LandingPracticeTestTemplatePageLayout>
      )}

      {pageType === PageTypeEnum.LAND_K12_CHEMISTRY_EXAM_BOOK && (
        <LandingPracticeTestTemplatePageLayout {...pageProps}>
          <FABLandingHome />
          <K12OthersExamTestLandingPage {...pageProps} />
        </LandingPracticeTestTemplatePageLayout>
      )}
      {pageType === PageTypeEnum.LAND_K12_BIOLOGY_EXAM_BOOK && (
        <LandingPracticeTestTemplatePageLayout {...pageProps}>
          <FABLandingHome />
          <K12OthersExamTestLandingPage {...pageProps} />
        </LandingPracticeTestTemplatePageLayout>
      )}
      {pageType === PageTypeEnum.LAND_K12_GEOGRAPHY_EXAM_BOOK && (
        <LandingPracticeTestTemplatePageLayout {...pageProps}>
          <FABLandingHome />
          <K12OthersExamTestLandingPage {...pageProps} />
        </LandingPracticeTestTemplatePageLayout>
      )}

      {pageType === PageTypeEnum.LAND_K12_HISTORY_EXAM_BOOK && (
        <LandingPracticeTestTemplatePageLayout {...pageProps}>
          <FABLandingHome />
          <K12OthersExamTestLandingPage {...pageProps} />
        </LandingPracticeTestTemplatePageLayout>
      )}
      {pageType === PageTypeEnum.LAND_K12_CIVIC_EDUCATION_EXAM_BOOK && (
        <LandingPracticeTestTemplatePageLayout {...pageProps}>
          <FABLandingHome />
          <K12OthersExamTestLandingPage {...pageProps} />
        </LandingPracticeTestTemplatePageLayout>
      )}
      {pageType === PageTypeEnum.LAND_K12_AGRICULTURAL_TECHNOLOGY_EXAM_BOOK && (
        <LandingPracticeTestTemplatePageLayout {...pageProps}>
          <FABLandingHome />
          <K12OthersExamTestLandingPage {...pageProps} />
        </LandingPracticeTestTemplatePageLayout>
      )}
      {pageType === PageTypeEnum.LAND_K12_INDUSTRIAL_TECHNOLOGY_EXAM_BOOK && (
        <LandingPracticeTestTemplatePageLayout {...pageProps}>
          <FABLandingHome />
          <K12OthersExamTestLandingPage {...pageProps} />
        </LandingPracticeTestTemplatePageLayout>
      )}

      {pageType === PageTypeEnum.LAND_K10_EXAM_BOOK && (
        <LandingPracticeTestTemplatePageLayout {...pageProps}>
          <FABLandingHome />
          <ContactDol />
          <K10ExamTestLandingPage {...pageProps} />
        </LandingPracticeTestTemplatePageLayout>
      )}

      {pageType === PageTypeEnum.LANDING_DICTATION && (
        <LandingDictationTemplatePageLayout {...pageProps}>
          <FABLandingHome />
          <ContactDol />
          <LandingDictationTemplatePage {...pageProps} />
        </LandingDictationTemplatePageLayout>
      )}

      {pageType === PageTypeEnum.LANDING_LISTENING_PRACTICE_TEST && (
        <LandingPracticeTestTemplatePageLayout {...pageProps}>
          <FABLandingHome />
          <ContactDol />
          <LandingListeningPracticeTestTemplatePage {...pageProps} />
        </LandingPracticeTestTemplatePageLayout>
      )}

      {pageType === PageTypeEnum.DO_DICTATION && <DoDictationTemplatePage {...pageProps} />}

      {pageType === PageTypeEnum.DO_TEST && <DoTestTemplatePage {...pageProps} />}

      {pageType === PageTypeEnum.LANDING_DAILY_LEARNING_NEWS && (
        <LandingDailyLearningTemplatePage {...pageProps} />
      )}

      {pageType === PageTypeEnum.DAILY_LEARNING_NEWS && (
        <DailyLearningNewsTemplatePage {...pageProps} />
      )}

      {pageType === PageTypeEnum.BOOK && <BookSEOPageTemplate {...pageProps} />}
      {pageType === PageTypeEnum.K12_EXAM_BOOK && <K12BookPage {...pageProps} />}

      {pageType === PageTypeEnum.K12_MATH_EXAM_BOOK && <K12OthersBookPage {...pageProps} />}
      {pageType === PageTypeEnum.K12_INFORMATICS_EXAM_BOOK && <K12OthersBookPage {...pageProps} />}
      {pageType === PageTypeEnum.K12_PHYSICS_EXAM_BOOK && <K12OthersBookPage {...pageProps} />}

      {pageType === PageTypeEnum.K12_CHEMISTRY_EXAM_BOOK && <K12OthersBookPage {...pageProps} />}
      {pageType === PageTypeEnum.K12_BIOLOGY_EXAM_BOOK && <K12OthersBookPage {...pageProps} />}
      {pageType === PageTypeEnum.K12_GEOGRAPHY_EXAM_BOOK && <K12OthersBookPage {...pageProps} />}

      {pageType === PageTypeEnum.K12_HISTORY_EXAM_BOOK && <K12OthersBookPage {...pageProps} />}
      {pageType === PageTypeEnum.K12_CIVIC_EDUCATION_EXAM_BOOK && <K12OthersBookPage {...pageProps} />}
      {pageType === PageTypeEnum.K12_AGRICULTURAL_TECHNOLOGY_EXAM_BOOK && <K12OthersBookPage {...pageProps} />}
      {pageType === PageTypeEnum.K12_INDUSTRIAL_TECHNOLOGY_EXAM_BOOK && <K12OthersBookPage {...pageProps} />}

      {pageType === PageTypeEnum.K10_EXAM_BOOK && <K10BookPage {...pageProps} />}
      {pageType === PageTypeEnum.K12_DO_TEST && <K12DoExamTestPage {...pageProps} />}
      {pageType === PageTypeEnum.K12_ALL_DO_TEST && <K12OthersDoExamTestPage {...pageProps} />}

      {pageType === PageTypeEnum.K10_DO_TEST && <K10DoExamTestPage {...pageProps} />}
      {pageType === PageTypeEnum.K12_VIEW_SOLUTION && (
        <K12ExamTestViewSolutionPage {...pageProps} />
      )}
      {pageType === PageTypeEnum.K12_ALL_VIEW_SOLUTION && (
        <K12ExamTestOthersViewSolutionPage {...pageProps} />
      )}
      {pageType === PageTypeEnum.K10_VIEW_SOLUTION && (
        <K10ExamTestViewSolutionPage {...pageProps} />
      )}
      {pageType === PageTypeEnum.K12_VIEW_TEST_QUESTION && (
        <K12ExamBlogLayout pageProps={pageProps}>
          <K12ExamTestBlogPage {...pageProps} />
        </K12ExamBlogLayout>
      )}
      {pageType === PageTypeEnum.K12_ALL_VIEW_TEST_QUESTION && (
        <K12ExamBlogLayout pageProps={pageProps}>
          <K12OthersExamTestBlogPage {...pageProps} />
        </K12ExamBlogLayout>
      )}
      {pageType === PageTypeEnum.K10_VIEW_TEST_QUESTION && (
        <K10ExamBlogLayout pageProps={pageProps}>
          <K10ExamTestBlogPage {...pageProps} />
        </K10ExamBlogLayout>
      )}
      {pageType === PageTypeEnum.LAND_HSA_EXAM_BOOK && (
        <LandingPracticeTestTemplatePageLayout {...pageProps}>
          <FABLandingHome />
          <ContactDol />
          <HSALandingPage {...pageProps} />
        </LandingPracticeTestTemplatePageLayout>
      )}
      {pageType === PageTypeEnum.HSA_EXAM_BOOK && <HSABookPage {...pageProps} />}
      {pageType === PageTypeEnum.HSA_DO_TEST && <HSADoExamTestPage {...pageProps} />}
      {pageType === PageTypeEnum.HSA_VIEW_SOLUTION && (
        <HSAFullTestViewSolutionPage {...pageProps} />
      )}
      {pageType === PageTypeEnum.HSA_VIEW_TEST_QUESTION && (
        <HSAFullTestViewTestBlog {...pageProps} />
      )}
    </>
  );
};
